'use client'

import type React from 'react'
import { Button } from 'react-aria-components/Button'
import { Menu, MenuTrigger, Popover } from 'react-aria-components/Menu'

import { css, cx } from '../../../../styled-system/css'
import { navbarItem } from '../recipe'

type DropdownMenuProps = {
    trigger: React.ReactNode
    menuClassName?: string
}

export function DropdownMenu({ children, trigger, menuClassName }: React.PropsWithChildren<DropdownMenuProps>) {
    return (
        <MenuTrigger>
            <Button className={navbarItem()}>{trigger}</Button>
            <Popover offset={-1} className={css({ position: 'relative' })}>
                <Menu
                    className={cx(
                        css({
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            right: '[auto]',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '[white]',
                            color: 'gray.600',
                            paddingY: '2',
                            borderRadius: 'md',
                            minWidth: '[160px]',
                            border: '[1px solid rgba(0, 0, 0, 0.15)]',
                            _focusVisible: { outline: 'none!' },
                        }),
                        menuClassName
                    )}
                >
                    {children}
                </Menu>
            </Popover>
        </MenuTrigger>
    )
}
